const shoppingCartDictES = {
  productType: "Tipo de producto:",
  soldBy: "Vendido por",
  pickUpInStore: "Recoger en la tienda", // Recoger en tienda
  orderResume: "Resumen del Pedido",
  shippingOptions: "Opciones de envío",
  checkCatalog: "Aprovecha nuestras ofertas",
  emptyCartText: "Tu carrito de compras está vacío.",
  emptyCartSuggestion:
    "Acceda a nuestra tienda y vea todas las ventajas de que Extraconomy puede ofrecer.",
  percentualCreditInfo: "información de porcentaje de crédito",
  shop: "Tienda",
  searchProducts: "Buscar productos...",
  searchByTitleInThisSubcategory: "Buscar en esa subcategoria...",
  byCap: "Por",
  product: "Producto",
  noResultsFound: "No se encontraron resultados.",
  shoppingCart: "Carrito de compras",
  cart: "Carrito",
  subtotal: "Subtotal",
  onlyOneSeller: "Solo puedes comprar productos de un vendedor.",
  items: "Artículos",
  platformFee: "Tarifa de la plataforma",
  total: "Total",
  walletBalance: "Saldo actual de su billetera",
  amountToPayWithWalletBalance: "Pague con el saldo de su billetera",
  amountToPayWithExtracredit: "Pague con Extracredit",
  sendYourTransferReceipt: "Envíe aquí el justificante de la transferencia",
  youWillNeedToTransfer: "Debe transferir",
  toTheBankAccount: "a la cuenta bancaria",
  andUploadTheReceipt: "y cargar el recibo",
  finishOrder: "Cerrar solicitud",
  finish: "Finalizar",
  goToPayment: "Ir para pago",
  searching: "Buscando",
  inSubcategory: "en la subcategoria",
  inAllProducts: "en todos los productos",
  productMaximumExtracoinPercent: "Porcentaje máximo de Extracredit (Producto)",
  userMaximumExtracoinPercent: "Porcentaje máximo de Extracredit (Usuario)",
  checkout: "Checkout",
  amountToPayAtCheckout: "Valor a pagar en el checkout",
  orderData: "Datos del pedido",
  howWillPay: "Cómo va a pagar",
  otherMethods: "Otras formas",
  creditRequested: "Crédito solicitado",
  moreDetails: "más detalles",
  productNotFound: "Producto no encontrado. Intente buscar en nuestro catálogo.",
  downloadableAndNonDownloadable:
    "Los productos descargables y no descargables no pueden estar en el mismo carrito.",
  balanceAvailable: "Saldo Extracredit disponible",
  freeExtracoinExplanation1: "Como",
  freeExtracoinExplanation2:
    "recién registrado, se le otorgará un pago Extracredit completo de forma gratuita en sus primeros tres pedidos, lo que significa que pagará el monto mínimo de compra sin gastar sus créditos Extracredit.",
  itemFavorited: "Ítem añadido a favoritos.",
  itemRemovedFromFavorites: "Ítem eliminado de favoritos.",
  info: "Info",
  searchForShipping: "Buscar opciones de envío para esta dirección postal",
  shippingQuotesFor: "Cotizaciones de envío para",
  pleasePickASendMethod:
    'Haga clic en el botón "Opciones de envío" y luego seleccione un método de envío',
  shippingCost: "Costo de envío",
  searchAddress: "Autocompletar con Código Postal",
  shippingResponsibilitySeller: "El envío es responsabilidad del vendedor",
  plataformFeeExplanation: "La tarifa de la plataforma es del 5% del valor total de los productos.",
  cashbackExplanation:
    "Cualquier cantidad que no se pague en extracredit tendrá el 50% convertido en cashback, regresando a su billetera en extracredit.",
  thankYouForYourPurchase: "Gracias por su compra",
  pleaseFillAllFieldsAddressOrSearchShippingMethod:
    "Complete todos los campos de dirección o haga clic en Opciones de envío.",
  deliveryAddress: "Dirección de entrega",
  pickUpAddress: "Recoge tu pedido en",
  orderId: "ID de pedido",
  orderDate: "Fecha de pedido",
  orderTotal: "Total de pedido",
  extraconomyExplain:
    "Tienes la flexibilidad de utilizar tu saldo Extracredit y/o saldo de la cartera para pagar tu pedido. Elige a continuación cuánto deseas usar de cada uno para completar tu compra.",
  orderInformation: "Información de pedido",
  goToMyShoppings: "Ir a mis compras",
  errorDontHavePhoneNumber:
    "No tienes un número de teléfono registrado. Complete su número de teléfono y código telefónico de país para continuar.",
  insufficientFunds: "fondos insuficientes",
  errorCheckout:
    "Se produjo un error al finalizar tu pedido. Contacta con soporte por WhatsApp al siguiente número. No olvides proporcionar la información a continuación.",
  contactEmail: "Entrar en contacto",
  yourOrderWillBeProcessed: "Su pedido se liberará una vez confirmada la transferencia.",
  weWillNotifyYou: "Se lo notificaremos por correo electrónico tras la confirmación.",
  creditCardInfo: "Ingrese los datos de su tarjeta de crédito",
  error: "Error",
  invalidCardDetails: "Complete correctamente los datos de su tarjeta de crédito",
  confirmation: "Confirmación",
  youDontHaveAddress: "No tienes una dirección registrada",
  paymentFinished: "Pago realizado con exito!",
  yourOrderWillBeReady: "Su pedido se confirmará cuando recibamos su pago.",
  paymentDone: "Pago realizado",
  orderDetailsCart: "Detalles de pedido",
  someItensMightBeDeliveredSeparately: "Algunos productos pueden ser entregados separadamente.",
  invoiceAddress: "Dirección de factura",
  shipToMyAddress: "Enviar a mi dirección",
  paypalPayment: "Pago con paypal o directamente en su cartera",
  myCredits: "Mis créditos",
  itemsRemoved: "Articulo removido del carrito",
  combinePaymentMethods: "Combinar 2 o más métodos de pago",
  combinePaymentExplanation: "Podrás combinar más de un método de pago para realizar tu compra.",
  selectPaymentMethod: "Selecciona el método de pago",
  paymentTermsAcceptance: "Al hacer clic en Pagar, aceptas nuestros términos generales de uso y los términos generales de venta de nuestros comerciantes.",
  payWithExtracreditAndWallet: "Paga con extracrédito y saldo de la cartera",
  payWithBankTransfer: "Paga con transferencia bancaria",
  payWithCreditCard: "Paga con tarjeta de crédito",
  payWithPayPal: "Paga tu compra con PayPal",
  continueShopping: "Continuar comprando",
  afterTransferUploadReceipt: "Después de realizar la transferencia, deberás cargar el comprobante a continuación.",
  uploadReceipt: "Cargar comprobante",
  receiptUploadedSuccessfully: "¡Comprobante enviado con éxito!",
  removeReceipt: "Eliminar comprobante",
  bankTransferImportantNote: "Importante: los pagos por transferencia bancaria no se procesan automáticamente. Nuestro equipo verificará para garantizar la seguridad de la transacción.",
  paymentWithExtracredit: "Pago con Extracrédito",
  toBeUsed: "para ser utilizado",
  paymentWithWallet: "Pago con Saldo de la Cartera",
  paymentCombination: "Combinación de Pagos",
  paymentCombinationExplanation: "Puedes combinar los valores de extracrédito y saldo de la cartera para completar tu pago. El valor total debe ser igual al valor de la compra.",
  paymentCompleteWithOtherMethods: "Pago completo con otros métodos",
  paymentCompleteWithOtherMethodsExplanation: "El monto total ya ha sido cubierto por los otros métodos de pago seleccionados.",
  totalAlreadyCovered: "Valor total ya cubierto",
  methodNotAvailable: "Método no disponible",
  methodNotAvailableExplanation: "Este método de pago no está disponible en este momento.",
  noWalletBalanceAvailable: "No tienes saldo disponible en la cartera",
  walletBalanceRequired: "Para usar este método de pago, necesitas tener saldo en tu cartera.",
  insufficientWalletBalance: "Saldo insuficiente",
  insufficientWalletBalanceMessage: "Tu saldo de {currency} {amount} no es suficiente para pagar el monto total de {currency} {total}. Elige otro método de pago o activa el modo de combinar pagos.",
  noExtracreditAvailable: "No tienes extracredit disponible",
  extracreditRequired: "Para usar este método de pago, necesitas tener saldo en tu extracredit.",
  insufficientExtracredit: "Saldo insuficiente",
  insufficientExtracreditMessage: "Tu saldo de {currency} {amount} no es suficiente para pagar el monto total de {currency} {total}. Elige otro método de pago o activa el modo de combinar pagos.",
  extracreditAmountDescription: "Ingresa un monto que será usado de tu saldo de extracrédito.",
  walletAmountDescription: "Ingresa un monto que será usado del saldo de tu cartera.",
  modify: "Modificar",
  freight: "Flete",
  free: "Gratis",
  lookingTheBestShippingMethod: "Buscamos el mejor método de envío",
  processingPayment: "Procesando pago...",
  userInfoDialogTitle: "Información del usuario",
  userInfoDialogDescription: "Para continuar con el checkout, necesitamos que complete alguna información obligatoria.",
  requiredUserInfo: "Datos de facturación",
  fillRequiredUserInfo: "Completar información obligatoria",
  fillRequiredUserInfoDescription: "Necesita completar alguna información obligatoria para continuar con el checkout (nombre completo, teléfono y documento de identificación).",
  firstName: "Nombre",
  lastName: "Apellido",
  surname: "Apellido",
  phone: "Teléfono",
  invalidPhoneNumber: "Número de teléfono inválido",
  documentType: "Tipo de documento",
  enterYourFirstName: "Ingrese su nombre",
  enterYourLastName: "Ingrese su apellido",
};

export default shoppingCartDictES;
